module.exports = __webpack_public_path__ + "img/Melli.fbe5f49a.svg";